// extracted by mini-css-extract-plugin
module.exports = {"container":"lopd_container__12TZm","wrapper":"lopd_wrapper__2vFCI","content":"lopd_content__2_GCr","title":"lopd_title__5MDK7","subtitles":"lopd_subtitles__gubOn"};